import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { Utils } from 'src/app/core/resources/utils';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { CargoClassifierService, CargoClassificationResult } from 'src/app/core/services/cargo-classifier.service';
@Component({
  selector: 'app-massive-cargo-operation',
  templateUrl: './massive-cargo-operation.component.html',
  styleUrls: ['./massive-cargo-operation.component.scss']
})
export class MassiveCargoOperationComponent {
  consecutivesControl: FormControl = new FormControl('', Validators.required);
  consecutiveList: Array<string> = [];
  availableList: Cargo[] = [];
  unavailableList: (Cargo & { errorMessage?: string })[] = [];
  nonExistentList: number[] = [];

  constructor(
    public dialogRef: MatDialogRef<MassiveCargoOperationComponent>,
    public utils: Utils,
    public snackbarService: SnackBarService,
    public spinner: NgxSpinnerService,
    private cargoClassifier: CargoClassifierService,
    @Inject(MAT_DIALOG_DATA) public dialogParams: {
      title: string,
      subtitle: string,
      label: string,
      confirmButton: string,
      method: Function,
      validationToCheckValid?: Function,
      filters?: string,
      receiveAsList?: boolean,
    },
  ) { }

  async processConsecutives() {
    // Reset lists
    this.consecutiveList = [];
    this.availableList = [];
    this.unavailableList = [];
    this.nonExistentList = [];
    if (this.consecutivesControl.invalid) return this.snackbarService.openSnackBar(FormMessages.AT_LEAST_ONE_ELEMENT, undefined, 'alert');
    this.spinner.show();
    try {
      const result = await this.cargoClassifier.classifyCargosByConsecutives(
        this.consecutivesControl.value,
        {
          searchMethod: this.dialogParams.method as any,
          validationMethod: this.dialogParams.validationToCheckValid as any,
          filters: this.dialogParams.filters,
          receiveAsList: this.dialogParams.receiveAsList || false,
          showMessages: true
        }
      );
      this.updateListsFromResult(result);
      if (result.nonExistentList.length !== result.totalProcessed) {
        this.dialogRef.close(result);
      }
    } catch (error) {
      console.error('Error processing consecutives:', error);
      this.snackbarService.openSnackBar('Error procesando consecutivos', undefined, 'error');
    } finally {
      this.spinner.hide();
    }
  }

  private updateListsFromResult(result: CargoClassificationResult) {
    this.availableList = result.availableList;
    this.unavailableList = result.unavailableList;
    this.nonExistentList = result.nonExistentList;
    this.consecutiveList = result.consecutiveList;
  }

}
